import { useEffect, useRef, useState } from "react";
import { useKey, useKeyPressEvent } from "react-use";
var revealFocused = function(parent, child) {
    if (!child || !parent) {
        return;
    }
    var itemOffsetRelativeToParent = child.offsetParent === parent ? child.offsetTop : child.offsetTop - parent.offsetTop;
    var scrollTop = parent.scrollTop;
    // Top not visible
    if (itemOffsetRelativeToParent < scrollTop) {
        scrollTop = itemOffsetRelativeToParent;
    }
    // Bottom not visible
    if (itemOffsetRelativeToParent + child.offsetHeight > scrollTop + parent.offsetHeight) {
        scrollTop = itemOffsetRelativeToParent + child.offsetHeight - parent.offsetHeight;
    }
    if (scrollTop !== parent.scrollTop) {
        parent.scrollTo({
            top: scrollTop
        });
    }
};
var useKeyNavigation = function(items, listRef, handleEnter) {
    var ref = useState(0), focusedItem = ref[0], setFocusedItem = ref[1];
    var ignoreMouse = useRef(false);
    var up = function() {
        setFocusedItem(function(item) {
            if (item === null) {
                return 0;
            }
            if (item === 0) {
                return items.length - 1;
            }
            return item - 1;
        });
    };
    var down = function() {
        setFocusedItem(function(item) {
            if (item === null || item === items.length - 1) {
                return 0;
            }
            return item + 1;
        });
        return 0;
    };
    var navigate = function(directionHandler) {
        ignoreMouse.current = true;
        directionHandler();
        setTimeout(function() {
            ignoreMouse.current = false;
        }, 100);
    };
    useKey("ArrowUp", function() {
        navigate(up);
    });
    useKey("ArrowDown", function() {
        navigate(down);
    });
    useKeyPressEvent("Enter", function(e) {
        if (focusedItem === null) {
            return;
        }
        e.preventDefault();
        handleEnter(items[focusedItem]);
    });
    useEffect(function() {
        var parent = listRef.current;
        var child = focusedItem !== null ? parent === null || parent === void 0 ? void 0 : parent.children[focusedItem] : null;
        revealFocused(parent, child);
    }, [
        listRef,
        focusedItem
    ]);
    var onMouseEnter = function(index) {
        if (!ignoreMouse.current) {
            setFocusedItem(index);
        }
    };
    var onMouseLeave = function() {
        if (!ignoreMouse.current) {
            setFocusedItem(null);
        }
    };
    return {
        focusedItem: focusedItem,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    };
};
export { useKeyNavigation };
